//@ts-expect-error imported library
import { tgaParseTAInstrumentsXLS } from 'physical-chemistry-parser';
import { Analysis } from "../index.js";
/**
 * Parse a TA Instruments Excel TGA export.
 * @param arrayBuffer - Raw binary data from the TA Instruments Excel file.
 * @returns An Analysis instance containing the parsed TGA spectra.
 */
export function fromTAInstrumentsExcel(arrayBuffer) {
    const analysis = new Analysis();
    const parsed = tgaParseTAInstrumentsXLS(arrayBuffer);
    const cheminfo = { meta: { method: 'Full' } };
    analysis.pushSpectrum(parsed.variables, {
        dataType: 'TGA',
        title: parsed.meta['Sample name'],
        meta: {
            ...parsed.meta,
            cheminfo,
        },
    });
    for (const sheet of parsed.sheets) {
        const sheetCheminfo = { meta: { method: sheet.name } };
        analysis.pushSpectrum(sheet.variables, {
            dataType: 'TGA',
            title: parsed.meta['Sample name'],
            meta: {
                ...parsed.meta,
                cheminfo: sheetCheminfo,
            },
        });
    }
    return analysis;
}
//# sourceMappingURL=fromTAInstrumentsExcel.js.map